const VideoBlock = ({ block }) => {
  const content = block.content;
  let maxWidth = content.width;
  if (maxWidth) {
    const maxWidthNumber = parseInt(maxWidth.replace("px", ""));
    if (maxWidthNumber > 1080 || typeof maxWidthNumber !== "number")
      maxWidth = "1080px";
  } else {
    maxWidth = "1080px";
  }

  return (
    <video
      height={content.height}
      poster={`${content.poster}`}
      controls
      className="video-block"
      style={{ maxWidth }}
    >
      <source src={`${content.src}`} />
    </video>
  );
};

export default VideoBlock;